import { useCallback, useState } from 'react'
export const filterOptions = [
  { id: 'AC', value: 'AC', label: 'Activos' },
  { id: 'SU', value: 'SU', label: 'Suspendidos' },
  { id: 'EP', value: 'EP', label: 'En Proceso' },
]
const useTableFilterStatus = () => {
  const [employeeStatus, setEmployeeStatus] = useState(filterOptions[0]?.id)

  const handleStatusChange = useCallback((value) => {
    setEmployeeStatus(value)
  }, [])

  return { employeeStatus, handleStatusChange }
}

export default useTableFilterStatus
